define('datakit/ajax',['require','exports','module','jquery','underscore','backbone','create-error','backbone.radio','bluebird'],function(require, exports, module){
  var $           = require('jquery');
  var _           = require('underscore');
  var Backbone    = require('backbone');
  var createError = require('create-error');
  var Radio       = require('backbone.radio');
  var Promise     = require('bluebird');

  var XHRError = createError('XHRError');
  var AbortError = createError(XHRError, 'AbortError');
  var XHRResponseError = createError('XHRResponseError');

  Radio.channel('datakit')
    .reply('AbortError', _.constant(AbortError))
    .reply('XHRResponseError', _.constant(XHRResponseError))
    .reply('XHRError', _.constant(XHRError));


  var ajax = {

    connections: [],

    XHRError: XHRError,
    XHRResponseError: XHRResponseError,
    AbortError: AbortError,

    channel: Radio.channel('ajax'),

    enable: function() {
      ajax._enabled = true;
      Backbone.ajax = ajax.request;
      return ajax;
    },

    isEnabled: function() {
      return !!ajax._enabled;
    },

    abortAll: function() {
      var connection;
      while (ajax.connections.length > 0) {
        var connection = ajax.connections.shift();
        ajax.abortConnection(connection);
      }
      return ajax;
    },

    abort: function(pool) {
      var matched = ajax.getPool(pool);

      for (var i = 0, len = matched.length, connection, index; i < len; i++) {
        connection = matched[i];
        ajax.abortConnection(connection);
        ajax.removeConnection(connection);
      }

      return matched;
    },

    getConnection: function(xhr) {
      for (var i = 0, len = ajax.connections.length, connection; i < len; i++) {
        connection = ajax.connections[i];
        if (connection.xhr === xhr) {
          return connection;
        }
      }
      return null;
    },

    getPool: function(pool) {
      var matched = [];

      pool = pool || 'default';

      for (var i = 0, len = ajax.connections.length, connection; i < len; i++) {
        connection = ajax.connections[i];
        if (connection.pool === pool) {
          matched.push(connection);
        }
      }
      return matched;
    },

    createConnection: function(xhr, options) {
      return { xhr: xhr, pool: options.pool || 'default' };
    },

    abortConnection: function(connection) {
      connection.xhr.abort();
      ajax.channel.trigger('abort', connection);
    },

    removeConnection: function(connection) {
      var index = _.indexOf(ajax.connections, connection);
      if (index >= 0) {
        ajax.connections.splice(index, 1);
      }
      return ajax;
    },

    isValidResponse: function(data, statusCode, jqXhr) {
      return true;
    },

    request: function(options) {
      var promise    = null,
          connection = null,
          xhr        = null,
          running    = true,
          error      = null,
          complete   = null,
          success    = null;

      options  = options ? _.clone(options) : {};
      error    = options.error
      success  = options.success
      complete = options.complete;

      // create a promise method to wrap the request
      promise = new Promise(function(resolve, reject) {
        // tack on a success handler to the options
        options.success = function(data, statusCode, jqXhr) {
          running = false;
          // if the success chain throws an error
          // we can pass it down the reject chain
          try {
            if (!ajax.isValidResponse(data, statusCode, jqXhr)) {
              throw new XHRResponseError('Invalid Response', { data: data, xhr: jqXhr });
            }
            if (success) { success.apply(this, arguments); }
          } catch(e) {
            reject(e);
            return;
          }
          resolve(data);
        }
        // tack on an error handler to the options
        options.error = function(jqXHR, statusText, err) {
          running = false;

          //error callback is not done directly in options
          //rather, the error promise is rejected, and the
          //rejection/error is caught immediately, the
          //error callback is triggered, and then the
          //rejection/error is continued.  This is done to
          //ensure that the promise rejection has the same
          //error object as the error callback fn

          try {
            if (err instanceof Error) {
              throw err;
            } else if (statusText === 'abort') {
              // if we have an abort error then
              // throw an AbortError
              throw new AbortError(statusText || 'AbortError', { xhr: xhr });
            } else {
              throw new XHRError(statusText || 'XHRError', { xhr: xhr });
            }
          } catch (e) {
            reject(e);
            return;
          }
        }
        options.complete = function() {
          ajax.channel.trigger('connection:complete', connection);
          ajax.removeConnection(connection);

          if (ajax.getPool(connection.pool).length < 1) {
            ajax.channel.trigger('pool:complete', connection.pool);
            ajax.channel.trigger('pool:complete:' + connection.pool);
          }
        }
      })
      .caught(function(e) {
        ajax.channel.trigger('error', e, connection);
        if (error) { error.apply(this, arguments); }
        throw e;
      });

      // DO IT!
      // make the ajax request and pass through
      // all options
      xhr = $.ajax(options);

      connection = ajax.createConnection(xhr, options);

      ajax.channel.trigger('connection:start', connection);

      if (ajax.getPool(connection.pool).length < 1) {
        ajax.channel.trigger('pool:start', connection.pool);
        ajax.channel.trigger('pool:start:' + connection.pool);
      }

      // in case the request happend sync...don't add
      if (running) {
        ajax.connections.push(connection);
      }

      // allow the xhr to have a reference to the promise
      xhr.promise = function() {
        return promise;
      };

      return xhr;
    }

  };

  Radio.channel('datakit').once('enable', function() {
    ajax.enable();
  });

  module.exports = ajax;
});

